var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nested-menu-tab-drop-down-container"},[_c('nested-menu-tab-drop-down',{attrs:{"title":_vm.$t('members'),"icon":"icon-user","route":"configuration.members","menus":[
    { title: _vm.$t('groups'), route: 'configuration.members.groups' },
    { title: _vm.$t('levels'), route: 'configuration.members.levels' },
    { title: _vm.$t('custom_fields'), route: 'configuration.members.custom_fields' }
  ]}}),_c('nested-menu-tab-drop-down',{attrs:{"title":_vm.$tc('consultation'),"icon":"icon-list","route":"configuration.consultation","menus":[
    { title: _vm.$t('inquiry'), route: 'configuration.consultation.inquiry' },
    { title: _vm.$tc('department', 2), route: 'configuration.consultation.department' },
    { title: _vm.$t('big'), route: 'configuration.consultation.big' },
    { title: _vm.$t('small'), route: 'configuration.consultation.small' },
    { title: _vm.$t('custom_fields'), route: 'configuration.consultation.custom_fields' }
  ]}}),_c('nested-menu-tab-drop-down',{attrs:{"title":_vm.$t('inbound'),"icon":"icon-phone","route":"configuration.inbound","menus":[
    { title: _vm.$t('ring_group'), route: 'configuration.inbound.ringGroup' },
    { title: _vm.$t('ivr'), route: 'configuration.inbound.ivr' },
    { title: _vm.$t('callback_group'), route: 'configuration.inbound.callbackGroup' }
  ]}}),_c('nested-menu-tab-drop-down',{attrs:{"title":_vm.$t('tasks'),"icon":"icon-list","route":"configuration.task","menus":[
    { title: _vm.$t('category'), route: 'configuration.task.category' }
  ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }